import { lazy, Suspense, useState } from 'react';

import type { AudienceActivationSheetProps } from './AudienceActivationSheet';

/**
 * The Activate wizard is one of the larger parts of the app and opens only on a click, so it is kept out
 * of the first page's JavaScript and loaded the first time it opens (the initial-JS budget, ACT2-1008;
 * ACT2-1287's wizard checks pushed the first page over it).
 */
const AudienceActivationSheet = lazy(() =>
  import('./AudienceActivationSheet').then((module) => ({ default: module.AudienceActivationSheet })),
);

/**
 * `AudienceActivationSheet`, loaded on first open. Nothing renders until `open` is first true; after
 * that it stays mounted like the sheet itself, so closing still animates and reopening is instant.
 */
export function LazyAudienceActivationSheet(props: AudienceActivationSheetProps): React.ReactElement | null {
  const [opened, setOpened] = useState(props.open);
  // Derived from props during render, React's own pattern for state that follows a prop.
  if (props.open && !opened) setOpened(true);
  if (!opened) return null;
  return (
    <Suspense fallback={null}>
      <AudienceActivationSheet {...props} />
    </Suspense>
  );
}
